import {createRouter, createWebHistory} from 'vue-router'
import {useUserStore} from "@/stores/user.ts";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: ()=> import('../views/servicesListView.vue'),
    },
    {
      path: '/login',
      name: 'login',
      component: ()=> import('../views/auth/LoginView.vue'),
    },
    {
      path: '/password/reset',
      name: 'password.reset',
      component: ()=> import('../views/auth/PasswordResetView.vue'),
    },
    {
      path: '/password/change/:id/:token',
      name: 'password.change',
      component: ()=> import('../views/auth/PasswordChangeView.vue'),
    },

    {
      path: '/register',
      name: 'register',
      component: ()=> import('../views/auth/registerView.vue'),
    },
    {
      path:'/services',
      name:'services.index',
      component: ()=> import('../views/servicesListView.vue'),

    },
    {
      path:'/services/:id',
      name:'services.view',
      component: ()=> import('../views/servicesSingleView.vue'),
    },
    {
      path:'/info/:url',
      name:'infos.url',
      component: () => import('../views/infoView.vue'),
    },
    {
      path:'/reservations',
      name:'reservations.index',
      component: () => import('../views/reservationsIndex.vue'),
    },
    {
      path:'/profile',
      name:'profile.index',
      component: () => import('../views/auth/profileView.vue'),
    },

    {
      path:'/administration/services',
      name:'administration.services',
      component: () => import('../views/administrators/servicesListView.vue'),
      meta: { isAdmin: true},
    },
    {
      path:'/administration/services/:id',
      name:'administration.services.edit',
      component: () => import('../views/administrators/servicesEditView.vue'),
      meta: { isAdmin: true},
    },
    {
      path:'/administration/services-options/:service_id/:id',
      name:'administration.services.options.edit',
      component: () => import('../views/administrators/serviceOptionsEditView.vue'),
      meta: { isAdmin: true},
    },

    {
      path:'/administration/persons',
      name:'administration.persons',
      component: () => import('../views/administrators/PersonsListView.vue'),
      meta: { isAdmin: true},
    },
    {
      path:'/administration/persons/:id',
      name:'administration.persons.edit',
      component: () => import('../views/administrators/personsEditView.vue'),
      meta: { isAdmin: true},
    },
    {
      path:'/administration/infos',
      name:'administration.infos',
      component: () => import('../views/administrators/infosListView.vue'),
      meta: { isAdmin: true},
    },
    {
      path:'/administration/infos/:id',
      name:'administration.infos.edit',
      component: () => import('../views/administrators/infosEditView.vue'),
      meta: { isAdmin: true},
    },
    {
      path:'/administration/working-time',
      name:'administration.working.time.edit',
      component: () => import('../views/administrators/WorkingTimeView.vue'),
      meta: { isAdmin: true},
    },
    {
      path:'/administration/reservations',
      name:'administration.reservations.index',
      component: () => import('../views/administrators/ReservationsListView.vue'),
      meta: { isAdmin: true},
    },

    {
      path:'/administration/users',
      name:'administration.users.index',
      component: () => import('../views/administrators/UsersListView.vue'),
      meta: { isAdmin: true},
    },



  ],
})
router.beforeEach(async (to, from, next) => {
  console.log(to.name);
  const userStore = useUserStore();
  await userStore.me();
  const isAuthenticated = !!userStore.auth?.id;
  const isAdmin = userStore.auth?.is_admin;

  if (
      !isAuthenticated && to.name !== 'login'
      && to.name !== 'register'
      && to.name !== 'password.reset'
      && to.name !== 'password.change'
      && to.name !== 'infos.url'
      && to.name !== 'home'
      && to.name !== 'services.index'
  ) {
    return next({name: 'login'});
  }

  if (to.path.startsWith('/administration')) {
    if (isAdmin === 1) {
      return next();
    }
    if (isAdmin === 2 && to.name === 'administration.reservations.index') {
      return next();
    }
    return next({ name: 'services.index' });
  }

  next();
});
export default router
